import { BlastworksClientEvent, ClientController } from 'client-controller';
import { FowlRequestSpinState } from 'state-machine/states/fowl-request-spin-state';

/**
 * Social request spin state, sends spin result message
 *
 * @class SocialRequestSpinState
 * @typedef {SocialRequestSpinState}
 * @extends {PYLSlingoRequestSpinState}
 */
export class SocialRequestSpinState extends FowlRequestSpinState {
  /**
   * Send complete message
   *
   * @public
   * @override
   */
  public complete(): void {
    ClientController.getInstance().raiseEvent(BlastworksClientEvent.SPIN_RESULT);
    super.complete();
  }
}
